import api from '@/services/api'

export default {
    login(data) {
        return api.post('/api-token-auth/', data)
    },
    fetchProfile(id) {
        return api.get(`api/users/${id}/`)
            .then(response => response.data)
    },
    updateProfile(id, payload) {
        return api.patch(`api/users/${id}/`, payload)
            .then(response => response.data)
    },
    sendPasswordResetEmail(payload) {
        return api.post('api/password_reset/', payload)
            .then(response => response.data)
    },
    resetPassword(payload) {
        return api.post('api/password_reset/confirm/', payload)
            .then(response => response.data)
    }
}
